import React, { useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import closeIcon from '../assets/images/Close.svg';

// Custom Arrow Components
const NextArrow = ({ onClick, currentSlide, slideCount }) => {
  const isLastSlide = currentSlide === slideCount - 1;

  return (
    <button
      onClick={onClick}
      className={`custom-arrow arrow-right ${isLastSlide ? 'disabled' : ''}`}
    >
      <span className="a-fd">
        <svg width="18" height="18" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 6.00001L37 27L16 48" stroke="#ffffffbf" strokeWidth="7.46667" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </span>
    </button>
  );
};

const PrevArrow = ({ onClick, currentSlide }) => {
  const isFirstSlide = currentSlide === 0;

  return (
    <button
      onClick={onClick}
      className={`custom-arrow arrow-left ${isFirstSlide ? 'disabled' : ''}`}
    >
      <span className="a-fd">
        <svg width="18" height="18" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 6.00001L37 27L16 48" stroke="#ffffffbf" strokeWidth="7.46667" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </span>
    </button>
  );
};

// Lightbox Component with Slider
const Lightbox = ({ media, currentIndex, onClose }) => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: media.length > 1, // Only show arrows if more than 1 item
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    initialSlide: currentIndex,
  };

  return (
    <div className="lightbox-overlay" onClick={onClose}>
      <div className="lightbox-container" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="lightbox-close-btn">
          {/* <img src={closeIcon} alt="Close" /> */}×
        </button>

        <Slider {...settings}>
          {media.map((item, index) => (
            <div key={index}>
              {item.file_type === 'video' ? (
                <div className="lightbox-media">
                  <video controls className="media-content">
                    <source src={item.url} />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ) : (
                <div className="lightbox-media">
                  <img src={item.url} alt={`Slide ${index + 1}`} className="media-content" />
                </div>
              )}
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

// Single Media Component
const SingleMedia = ({ item, onImageClick, index }) => {
  return (
    <div className="single-media-container">
      {item.file_type === 'video' ? (
        <video controls className="media-content" onClick={() => onImageClick(index)}>
          <source src={item.url} />
          Your browser does not support the video tag.
        </video>
      ) : (
        <img
          src={item.url}
          alt="Media content"
          onClick={() => onImageClick(index)}
          className="media-image"
        />
      )}
    </div>
  );
};

const CustomSliderMessage = ({ media }) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: media.length > 1, // Only show arrows if more than 1 item
    autoplay: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="custom-slider">
      <Slider {...settings}>
        {media.map((item, index) => (
          <div key={index}>
            <SingleMedia item={item} onImageClick={openLightbox} index={index} />
          </div>
        ))}
      </Slider>

      {lightboxOpen && (
        <Lightbox
          media={media}
          currentIndex={currentIndex}
          onClose={closeLightbox}
        />
      )}
    </div>
  );
};

export default CustomSliderMessage;
